import { injectable } from 'inversify'

@injectable()
export class StorageService {
  private readonly storage = window.localStorage

  public getItem<T>(key: string): T | undefined {
    let item: T | undefined

    const value: string | null = this.storage.getItem(key)

    if (value != null) {
      try {
        item = JSON.parse(value) as T
      } catch (e) {
        this.removeItem(key)
      }
    }

    return item
  }

  public removeItem(key: string) {
    this.storage.removeItem(key)
  }

  public setItem<T>(key: string, value: T) {
    this.storage.setItem(key, JSON.stringify(value))
  }
}
